/**
 * 週末快閃機票搜尋器：從台灣出發，週五去週日/一回，三個月內低價
 * 資料由 Cloudflare Workers Cron 抓取並快取於 KV，此頁為展示與說明
 */
export function WeekendFlightRadarTool() {
  return (
    <>
      <div className="mb-6 rounded-lg border border-amber-200 bg-amber-50 p-6 dark:border-amber-800 dark:bg-amber-900/20">
        <h2 className="mb-2 text-lg font-semibold text-amber-900 dark:text-amber-100">
          即將上線
        </h2>
        <p className="mb-4 text-amber-800 dark:text-amber-200">
          本工具將由後端定時任務（Cron
          Triggers）抓取桃園、松山、小港出發，符合「週五出發、週日或週一回程」的低價機票，並快取於
          Cloudflare KV，開啟頁面即可秒開、無需即時查 API。
        </p>
        <p className="text-sm text-amber-700 dark:text-amber-300">
          上線後您將看到例如：「台北 → 首爾 約 NT$3,866」「高雄 → 沖繩 約
          NT$2,xxx」等週末快閃最低價一覽。
        </p>
      </div>

      <div className="mb-6 flex flex-col gap-4 lg:flex-row lg:items-start">
        <div className="flex-1 rounded-lg border border-gray-200 bg-gray-50 p-6 dark:border-gray-700 dark:bg-gray-800">
          <h2 className="mb-3 text-sm font-medium text-gray-700 dark:text-gray-300">
            預覽格式（示意）
          </h2>
          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead>
                <tr className="border-b border-gray-200 dark:border-gray-600">
                  <th className="py-2 text-left font-medium">出發 → 目的地</th>
                  <th className="py-2 text-right font-medium">約最低價</th>
                  <th className="py-2 text-left font-medium">區間</th>
                </tr>
              </thead>
              <tbody className="text-gray-700 dark:text-gray-300">
                <tr className="border-b border-gray-100 dark:border-gray-700">
                  <td className="py-2">桃園 → 首爾</td>
                  <td className="text-right font-medium text-primary">
                    NT$3,866
                  </td>
                  <td className="py-2">週五～週一</td>
                </tr>
                <tr className="border-b border-gray-100 dark:border-gray-700">
                  <td className="py-2">桃園 → 沖繩</td>
                  <td className="text-right font-medium text-primary">
                    NT$2,xxx
                  </td>
                  <td className="py-2">週五～週一</td>
                </tr>
                <tr>
                  <td className="py-2">松山 → 東京</td>
                  <td className="text-right font-medium text-primary">
                    NT$5,xxx
                  </td>
                  <td className="py-2">週五～週一</td>
                </tr>
              </tbody>
            </table>
          </div>
          <p className="mt-2 text-xs text-gray-500 dark:text-gray-400">
            以上為示意資料，實際以串接機票/比價 API 後顯示為準。
          </p>
        </div>
      </div>

      <section className="rounded-lg border border-gray-200 bg-white p-6 dark:border-gray-700 dark:bg-gray-800">
        <h2 className="mb-3 text-lg font-semibold text-gray-900 dark:text-gray-100">
          使用說明
        </h2>
        <p className="leading-relaxed text-gray-600 dark:text-gray-400">
          專門篩選從台灣（桃園、松山、高雄）出發，且符合週末快閃（週五去、週日或週一回）的低價機票，方便上班族快速找到「下週末去哪裡最便宜」。資料由定時任務抓取並快取，訪問速度快、不需即時查詢。
        </p>
      </section>
    </>
  );
}
